import { render } from "./TicketsRealization.vue?vue&type=template&id=5b985277"
import script from "./TicketsRealization.vue?vue&type=script&lang=js"
export * from "./TicketsRealization.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__